import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import { useState, useEffect } from 'react';

// Simple auto-close hook for pickers identified by an element id.
// Returns [open, setOpen]. When open is true, clicking outside the element
// with the given id or pressing Escape will set open to false.
export function usePickerAutoClose(pickerId) {
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    open = _useState2[0],
    setOpen = _useState2[1];
  useEffect(function () {
    if (!pickerId) return undefined;
    var onPointer = function onPointer(e) {
      try {
        var el = document.getElementById(pickerId);
        if (!el) return;
        if (el.contains(e.target)) return;

        // MUI pickers render calendar/clock in a portal. Treat interactions
        // inside picker poppers/dialogs as internal so month/time navigation
        // does not auto-close the picker.
        var target = e.target;
        if (target && target.closest) {
          var insidePickerPortal = target.closest('.MuiPickersPopper-root, .MuiPickersModal-root, .MuiPickersLayout-root');
          if (insidePickerPortal) return;
        }
        setOpen(false);
      } catch (err) {
        // ignore
      }
    };
    var onKey = function onKey(e) {
      if (e.key === 'Escape') setOpen(false);
    };
    document.addEventListener('mousedown', onPointer);
    document.addEventListener('touchstart', onPointer);
    document.addEventListener('keydown', onKey);
    return function () {
      document.removeEventListener('mousedown', onPointer);
      document.removeEventListener('touchstart', onPointer);
      document.removeEventListener('keydown', onKey);
    };
  }, [pickerId]);
  return [open, setOpen];
}
export default usePickerAutoClose;